export const numberFormatter = new Intl.NumberFormat('en-US')
